import React, { useEffect, useState } from "react";

const WebChat = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    let active = true;
    const script = document.createElement("script");

    const handleError = (message) => {
      if (!active) return;
      console.error(message);
      setError(true);
      setErrorMessage(message);
      setLoading(false);
    };

    script.src =
      "https://tcs.callcenterstudio.com/click2connects/click2connect.js?widget_key=ahRzfm11c3RlcmktaGl6bWV0bGVyaXIhCxIUQ2xpY2syQ29ubmVjdFBhY2thZ2UYgIDGnt3ozgkMogEYdGNzLmNhbGxjZW50ZXJzdHVkaW8uY29t";

    script.onload = () => {
      if (!active) return;

      try {
        if (typeof window.startWidget !== "function") {
          throw new Error(" Something Went Wrong");
        }

        window.startWidget();
        setLoading(false);
      } catch (err) {
        handleError(err.message);
      }
    };

    script.onerror = () => handleError(" Something Went Wrong");

    document.body.appendChild(script);

    return () => {
      active = false;
      script.remove();
    };
  }, []);

  return (
    <div className="relative w-full min-h-screen">
      {/* Loading */}
      {loading && (
        <div
          className="flex items-center justify-center min-h-screen"
          style={{
            backgroundColor: "rgba(31, 32, 41, 0.75)",
          }}
        >
          <div className="w-[50px] h-[50px] rounded-full border-4 border-gray-300 border-t-red-500 animate-spin" />
        </div>
      )}

      {!loading && !error && (
        <picture>
          <source
            media="(max-width: 767px)"
            srcSet="/webchat/mobilescreen.jpg"
          />

          <img
            src="/webchat/webscreen.jpg"
            alt="TCS Customer Support"
            className="w-full h-auto block"
          />
        </picture>
      )}

      {error && (
        <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4 text-center">
          <div className="w-20 h-20 rounded-full bg-red-50 flex items-center justify-center mb-6">
            <span className="text-red-600 text-5xl">!</span>
          </div>

          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3">
            {errorMessage}
          </h2>

          <p className="text-gray-500 text-base md:text-lg mt-2">
            Please try again later.
          </p>
        </div>
      )}
    </div>
  );
};

export default WebChat;
